import { JSX } from "react"
import { ContentEditable as LexicalContentEditable } from "@lexical/react/LexicalContentEditable"

type Props = {
  placeholder: string
  className?: string
  placeholderClassName?: string
}

export function ContentEditable({
  placeholder,
  className,
  placeholderClassName,
}: Props): JSX.Element {
  return (
    <LexicalContentEditable
      className={
        className ??
        `ContentEditable__root relative block min-h-48 max-h-64 overflow-auto px-4 py-3 focus:outline-none`
      }
      aria-placeholder={placeholder}
      placeholder={
        <div
          className={
            placeholderClassName ??
            `text-gray-400 pointer-events-none absolute top-0 left-0 overflow-hidden px-4 py-3 text-ellipsis select-none`
          }
        >
          {placeholder}
        </div>
      }
    />
  )
}
